(ns frontend.view.dashboard.leads-home.view
  (:require
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [frontend.view.components.bar-chart :as bar-chart]
   [frontend.view.components.oppos-per-users-chart :as users-chart]
   [frontend.view.components.top-performer-chart :as top-performer-chart]
   [ui.components.chart.view :as chart]
   [ui.components.card.view :as card]))

(defn component
  [data]
  [:div
   [card/card
    [card/header
     (loc/tr :home-lead-types)]
    [card/body
     [:div.md:grid.grid-cols-10.gap-4
      [:div
       {:class "col-span-5"}
       [chart/view
        (users-chart/options {:largest-bar-color "#8ABF4C"
                              :height 200}
                             (get-in data [:new-leads :per-user]))]]
      [:div
        {:class "col-span-5"}
       [top-performer-chart/component
        {:color "#8ABF4C"}
        (get-in data [:new-leads :top-performer])]]
      [:div
       {:class "col-span-10"}
       [chart/view
        (bar-chart/options
         {:grid-line-color  "#9CC969"
          :background-color "#8ABF4C"
          :labels-color     "#FFFFFF"
          :series-color     "#FFFFFF"
          :height           200}
         (get-in data [:lead-types]))]]]]]])
